import { DefaultQueryParams, PaginatedResponse } from '@frontend/api-utils';
import { Location } from '@frontend/common';

export interface Module {
    name: string | null;
    index: string;
    location: Location;
    dimension: ModuleDimension;
    update_timestamp: string;
    type: ModuleType;
    template_id: string | null;
    id: string;
    spot_id: string;
    creation_timestamp: string;
    delete_timestamp: string | null;
    account_id: string;
    doors: number;
    /** When false: platform/admin placeholder; kiosk SLOT grid. Missing/true = render. */
    renderable?: boolean;
}

export interface CreateModule {
    name?: string | null;
    type?: ModuleType | null;
    index?: string;
    location?: Location;
    template_id?: string | null;
    dimension?: ModuleDimension;
    doors?: number;
    renderable?: boolean;
}

export interface UpdateModule {
    null_fields?: string[] | null;
    name?: string | null;
    index?: string | null;
    location?: Location;
    type?: ModuleType | null;
    dimension?: ModuleDimension;
    doors?: number;
    renderable?: boolean | null;
}

export enum ModuleType {
    cabinet = 'cabinet',
    carousel = 'carousel',
    carousel_7_32pxxs_2pxs = 'carousel_7_32pxxs_2pxs',
    /** Legacy only — not accepted on create/update; kept for display of existing data */
    custom_rack = 'custom_rack',
    extension_16s = 'extension_16s',
    extension_24xs = 'extension_24xs',
    extension_2l_1xl = 'extension_2l_1xl',
    extension_48xxs = 'extension_48xxs',
    extension_4l = 'extension_4l',
    extension_4xxs_3xs_4s_2m_2l_1xl = 'extension_4xxs_3xs_4s_2m_2l_1xl',
    extension_8m = 'extension_8m',
    extension_8s_4m = 'extension_8s_4m',
    main_unit_1s_12_xxs_4m_two_face = 'main_unit_1s_12_xxs_4m_two_face',
    main_unit_5s_1m_drop_station = 'main_unit_5s_1m_drop_station',
    main_unit_5s_24xxs = 'main_unit_5s_24xxs',
    main_unit_5s_4m = 'main_unit_5s_4m',
    main_unit_9s = 'main_unit_9s'
}

export interface ModuleDimension {
    height: number;
    width: number;
    depth: number;
    type: 'box' | 'pie';
}

export type ModuleListResponse = PaginatedResponse<Module>;

export enum QueryParams {
    SPOT_ID = 'spot_id',
    MODULE_ID = 'module_id',
    PROTOCOL = 'protocol'
}

export type ModuleQueryParams = DefaultQueryParams | QueryParams;

export const zhilaiBoardData = [
    { label: 'A', value: '192.168.1.10' },
    { label: 'B', value: '192.168.1.11' },
    { label: 'C', value: '192.168.1.12' },
    { label: 'D', value: '192.168.1.13' },
    { label: 'E', value: '192.168.1.14' },
    { label: 'F', value: '192.168.1.15' },
    { label: 'G', value: '192.168.1.16' },
    { label: 'H', value: '192.168.1.17' },
    { label: 'I', value: '192.168.1.18' },
    { label: 'J', value: '192.168.1.19' },
    { label: 'K', value: '192.168.1.20' },
    { label: 'L', value: '192.168.1.21' },
    { label: 'M', value: '192.168.1.22' },
    { label: 'N', value: '192.168.1.24' },
    { label: 'Z', value: '192.168.1.25' }
];
